module.exports = "https://trybtryb-legacy.web.app/img/sell.f25a8576.webp";